import { Grid } from "@mui/material";
import React, { useState } from "react";
import Input from "../../components/Components/Input";
import CustomButton from "../../components/Components/Button";
import { MaterialOutwardMutation } from "./mutations/BarcodeMutations";
import { useMutation } from "react-query";
import { handleToastMsg } from "../../components/Components/Toast";
import CustomDivider from "../../components/Components/CustomDivider"

function BarcodeNonReturnable({ type = "", setModelToggle }) {
  const [barcodeValue, setBarcodeValue] = useState("");

  const { mutate } = useMutation(MaterialOutwardMutation);

  console.log({ type });

  const handleSubmit = (e) => {
    console.log({ barcodeValue }, "barcode");
    e.preventDefault();

    const payload = {
      barcodeValue,
    };
    mutate(payload, {
      onSuccess: (res) => {
        console.log({ res });
        handleToastMsg("Data updated successfully", "success");
        setModelToggle(false);
      },
      onError: (err) => {
        handleToastMsg(err.message, "error");
      },
    });
  };

  return (
    <Grid container style={{ paddingTop: '2%', paddingBottom: '2%' }}>
      <Grid container item xs={12} style={{ paddingBottom: "4%" }} justifyContent={'center'}>
        <p><b>Scan Barcode For Non Return Material</b></p>
        <CustomDivider />
      </Grid>
      <form style={{ width: "100%" }} onSubmit={handleSubmit}>
        <Grid container xs={12} justifyContent={'space-evenly'}>
          <Grid item xs={3}>
            <Grid item>
              <Input
                value={barcodeValue}
                onChange={(e) => setBarcodeValue(e.target.value)}
                placeholder={"Scan Invoice"}
                autofocus={true}
                name="Barcode"
              />
            </Grid>
          </Grid>
          <Grid item xs={3} container justifyContent={"flex-end"}>
            <CustomButton type="submit">Submit</CustomButton>
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
}

export default BarcodeNonReturnable;
